import authHttp, { API_ROOT } from "./auth-http";

export const HomeService = {
  getMeetOurFounders() {
    return authHttp.get(`${API_ROOT}/meetFounders/home`);
  },
};

export default HomeService;
